"use client"

import { Link } from "@i18n/navigation"
import React, { ComponentProps } from "react"

type LinkProps = ComponentProps<typeof Link>

export interface ClientLinkProps extends Omit<LinkProps, "href"> {
  children?: React.ReactNode
  href: LinkProps["href"] | (string & {})
  className?: string
  onClick?: () => void
  passHref?: true
}

/**
 * Use this component to create a Next.js `<Link />` that persists the current country code in the url,
 * without having to explicitly pass it as a prop.
 */
const ClientLink = ({ children, href, ...props }: ClientLinkProps) => {
  return (
    <Link href={href as any} {...props}>
      {children}
    </Link>
  )
}

export default ClientLink
